'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es6-symbol/index.js
 ** module id = 187
 ** module chunks = 0
 **/